import { scrollToId } from "@/lib/scroll";

export const Footer = () => (
  <footer
    data-testid="site-footer"
    className="relative border-t border-white/10 bg-navy-900 py-16"
  >
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid grid-cols-1 md:grid-cols-4 gap-10">
      <div className="md:col-span-2">
        <div className="flex items-center gap-2.5 mb-5">
          <span className="w-8 h-8 bg-gold-500 rounded-sm grid place-items-center font-display font-black text-navy-900 text-lg">
            G
          </span>
          <span className="font-display font-extrabold tracking-[0.18em] text-ice-50">
            GOLD LINK
          </span>
        </div>
        <p className="text-sm leading-relaxed text-ice-200/50 max-w-sm mb-6">
          Commercial & residential cleaning across the West Midlands.
          Hospital-grade standards, real-time reporting, zero disruption.
        </p>
        <p className="font-mono text-[11px] text-ice-200/40 leading-relaxed">
          18 The Parade, West Bromwich B71 3NY
          <br />
          +44 7491 147099 · hello@goldlinkcleaning.co.uk
        </p>
      </div>

      <div>
        <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-gold-500 mb-5">
          Explore
        </p>
        <ul className="space-y-3">
          {[
            { id: "services", label: "Sectors" },
            { id: "products", label: "Products" },
            { id: "protocol", label: "Protocol" },
            { id: "pricing", label: "Pricing" },
            { id: "quote", label: "Get a Quote" },
          ].map((l) => (
            <li key={l.id}>
              <button
                data-testid={`footer-link-${l.id}`}
                onClick={() => scrollToId(l.id)}
                className="text-sm text-ice-200/60 hover:text-gold-400 transition-colors"
              >
                {l.label}
              </button>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-gold-500 mb-5">
          Sectors
        </p>
        <ul className="space-y-3 text-sm text-ice-200/60">
          <li>Offices & Corporate HQ</li>
          <li>Pubs & Hospitality</li>
          <li>Care Homes & Healthcare</li>
          <li>Concerts & Venues</li>
          <li>Industrial & Automotive</li>
        </ul>
      </div>
    </div>

    <div className="max-w-7xl mx-auto px-5 sm:px-8 mt-14 pt-8 border-t border-white/5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
      <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-ice-200/30">
        © 2026 Gold Link Cleaning Services Ltd. All rights reserved.
      </p>
      <a
        data-testid="footer-admin-link"
        href="/admin"
        className="font-mono text-[10px] uppercase tracking-[0.18em] text-ice-200/30 hover:text-gold-400 transition-colors"
      >
        Staff Login
      </a>
    </div>
  </footer>
);
